import PropTypes from 'prop-types';
// form
import { Controller, useFormContext } from 'react-hook-form';
// @mui
import { FormHelperText } from '@mui/material';
//
import { Upload, UploadAvatar, UploadBox } from '../upload';

// ----------------------------------------------------------------------

RHFUploadAvatar.propTypes = {
  name: PropTypes.string,
};

// ----------------------------------------------------------------------

export function RHFUploadAvatar({ name, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <UploadAvatar
            accept={{
              'image/*': [],
            }}
            error={!!error}
            file={field.value}
            {...other}
          />

          {!!error && (
            <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}

// ----------------------------------------------------------------------

RHFUploadBox.propTypes = {
  name: PropTypes.string,
};

export function RHFUploadBox({ name, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <UploadBox files={field.value} error={!!error} {...other} />
      )}
    />
  );
}

// ----------------------------------------------------------------------

RHFUpload.propTypes = {
  name: PropTypes.string,
  multiple: PropTypes.bool,
  helperText: PropTypes.node,
  helperTextSx: PropTypes.object,
  accept: PropTypes.object,
  placeholderElementSx: PropTypes.object,
  placeholderIcon: PropTypes.string,
  placeholderHeading: PropTypes.node,
  placeholderDirection: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placeholderAlignItems: PropTypes.string,
  placeholderSpacing: PropTypes.number,
  hidePlaceholderDescription: PropTypes.bool,
  previewSx: PropTypes.object,
  enableEditImage: PropTypes.bool,
  showFileName: PropTypes.bool,
  compact: PropTypes.bool,
};

export function RHFUpload({
  name,
  multiple,
  helperText,
  helperTextSx,
  accept,
  placeholderElementSx,
  placeholderIcon,
  placeholderHeading,
  placeholderDirection,
  placeholderAlignItems,
  placeholderSpacing,
  hidePlaceholderDescription,
  previewSx,
  enableEditImage,
  showFileName,
  compact,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) =>
        multiple ? (
          <Upload
            multiple
            accept={accept || { 'image/*': [] }}
            files={field.value}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{ px: 2, ...helperTextSx }}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            placeholderElementSx={placeholderElementSx}
            placeholderIcon={placeholderIcon}
            placeholderHeading={placeholderHeading}
            placeholderDirection={placeholderDirection}
            placeholderAlignItems={placeholderAlignItems}
            placeholderSpacing={placeholderSpacing}
            hidePlaceholderDescription={hidePlaceholderDescription}
            previewSx={previewSx}
            enableEditImage={enableEditImage}
            showFileName={showFileName}
            compact={compact}
            {...other}
          />
        ) : (
          <Upload
            accept={accept || { 'image/*': [] }}
            file={field.value}
            error={!!error}
            onCrop={field.onChange}
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{ px: 2, ...helperTextSx }}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            placeholderElementSx={placeholderElementSx}
            placeholderIcon={placeholderIcon}
            placeholderHeading={placeholderHeading}
            placeholderDirection={placeholderDirection}
            placeholderAlignItems={placeholderAlignItems}
            placeholderSpacing={placeholderSpacing}
            hidePlaceholderDescription={hidePlaceholderDescription}
            previewSx={previewSx}
            enableEditImage={enableEditImage}
            showFileName={showFileName}
            compact={compact}
            {...other}
          />
        )
      }
    />
  );
}
